// extracted by mini-css-extract-plugin
export default {"container":"qK-z","error":"rK-z","disabled":"sK-z","submit":"tK-z","option":"uK-z","success":"vK-z","failure":"wK-z"};